import type { CSSProperties } from 'react'

// ============================================================================
// THE BAR'S AND THE + MENU'S SIZES — the one place to tune them.
//
// Board 03/04 values, as the owner adjusted them after trying Phase 1 on the S24 (2026-10-19):
//   · the + is 10% smaller than the board (56 → 50px), still centred in the 70px bar;
//   · the four menu items are ≈ 0.91× the board (disc 56 → 51, label pill 36 → 33, label text
//     15 → 13.5, icon 22 → 20, spacing 70 → 64);
//   · the bar sits 10px above the safe area instead of 20px.
// They are drawn at these CSS pixels whatever the app's size setting: the bar and the menu
// counter-zoom (index.css, `.m-bar-wrap`).
//
// index.css reads every value through the custom properties `shellSizeVars()` puts on the phone
// shell's root, and the gesture (tabGesture.ts) hit-tests with the same numbers, so changing one
// here moves the drawing and the finger's targets together.
// ============================================================================

export const SHELL_SIZES = {
  /** The capsule's height (board: 70). */
  bar: 70,
  /** Gap between the capsule and the bottom safe-area inset (board: 20; owner: 10). */
  barGap: 10,
  /** The + (board: 56; owner: 10% smaller). */
  cap: 50,
  /** The + glyph, scaled with it (board: 24 in 56). */
  capIcon: 21.5,
  /** A menu item's disc (board: 56). */
  menuDisc: 51,
  /** Its glyph (board: 22). */
  menuIcon: 20,
  /** The label pill's height (board: 36). */
  menuLabelHeight: 33,
  /** The label's type size (board: 15). */
  menuLabelText: 13.5,
  /** Space between the disc's left edge and the label pill (board: 12). */
  menuLabelGap: 11,
  /** The first item's centre above the +'s centre (board: 72 — scaled with the + and the disc). */
  menuFirst: 65,
  /** Centre to centre between items (board: 70). */
  menuStep: 64,
} as const

/** The sizes as the custom properties index.css reads, for the phone shell's root element. */
export function shellSizeVars(): CSSProperties {
  const s = SHELL_SIZES
  return {
    '--m-bar-h': `${s.bar}px`,
    '--m-bar-gap': `${s.barGap}px`,
    '--m-cap-size': `${s.cap}px`,
    '--m-cap-icon': `${s.capIcon}px`,
    '--m-menu-disc': `${s.menuDisc}px`,
    '--m-menu-icon': `${s.menuIcon}px`,
    '--m-menu-label-h': `${s.menuLabelHeight}px`,
    '--m-menu-label-text': `${s.menuLabelText}px`,
    '--m-menu-label-gap': `${s.menuLabelGap}px`,
    '--m-menu-first': `${s.menuFirst}px`,
    '--m-menu-step': `${s.menuStep}px`,
  } as CSSProperties
}
